/**未算税员工 */
import { $http, buildHeaders } from "./index";

//获取发薪单列表
export const uncalctaxemployee_list = (params) => {
  return $http.get("/admin/UnCalcTaxEmployee/index", { params });
};

//零申报
export const uncalctaxemployee_zerodeclares = (data) => {
  return $http.post("/admin/UnCalcTaxEmployee/zeroDeclares", data, {
    headers: buildHeaders(3),
  });
};

//离职报送
export const uncalctaxemployee_resignationdeclares = (data) => {
  return $http.post(
    "/admin/UnCalcTaxEmployee/resignationDeclares",
    { data },
    {
      headers: buildHeaders(3),
    }
  );
};

//导出
export const uncalctaxemployee_export = (params) => {
  return $http.get("/admin/UnCalcTaxEmployee/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//手动更新
export const uncalctaxemployee_update = (data) => {
  return $http.post("/admin/UnCalcTaxEmployee/manualSync", data, {
    headers: buildHeaders(3),
  });
};
